import type { DeleteSecureNoteRequest, ListSecureNotesRequest } from '@frontend/api-types';
import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'secure_notes';
const CONTENT = 'content';

export const SECURE_NOTES_ENDPOINTS = {
  createSecureNoteContent: () => formatEndpoint('', namespace),
  deleteSecureNote: ({ secureNoteId, taskId }: DeleteSecureNoteRequest) =>
    formatEndpoint(`${secureNoteId}`, namespace, { queryParams: { task_id: taskId } }),
  listSecureNotes: ({ clientId }: ListSecureNotesRequest) =>
    formatEndpoint('', namespace, { queryParams: { client_id: clientId } }),
  replaceSecureNoteContent: (secureNoteId: string) => formatEndpoint(`${secureNoteId}/${CONTENT}`, namespace),
  retrieveSecureNoteContent: (secureNoteId: string) => formatEndpoint(`${secureNoteId}/${CONTENT}`, namespace),
};
